/* eslint-disable @typescript-eslint/no-explicit-any */
import { CaretDownOutlined, Loading3QuartersOutlined } from "@ant-design/icons";
import {
  Avatar,
  Button,
  Card,
  Carousel,
  Col,
  Dropdown,
  Image,
  Row,
  Spin,
  Switch,
  Tag,
} from "antd";
import {
  AngleRight,
  ContractsIcon,
  PlusIcon,
  TickIcon,
} from "../../../../../../../../atoms/CustomIcons";
import { useState } from "react";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  tableRecord: any;
  loading: boolean;
}

const TaskModal = (props: PropsType) => {
  const { loading } = props;
  const [requiredProof, setRequiredProof] = useState<boolean>(false);

  // const contentStyle: React.CSSProperties = {
  //   margin: 0,
  //   height: "160px",
  //   color: "#fff",
  //   lineHeight: "160px",
  //   textAlign: "center",
  //   // background: "#364d79",
  //   // backgroundImage: "url(/images/work-orders/landscape-demo.jpg)",
  //   // backgroundRepeat: "no-repeat",
  //   // backgroundPosition: "center",
  //   // backgroundSize: "cover",
  // };

  const statusItems = [
    {
      key: "open",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#6C7478", borderRadius: "2px" }}
          />{" "}
          Open{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "scheduled",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#6454F4", borderRadius: "2px" }}
          />{" "}
          Scheduled{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "completed",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#00A07D", borderRadius: "2px" }}
          />{" "}
          Completed{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "in_progress",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#943AF5", borderRadius: "2px" }}
          />{" "}
          In progress{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
  ];

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Row wrap={false} gutter={8} className="TaskModalWrapper">
        <Col flex="auto" className="TaskModalLeft">
          <Card className="taskModalCard">
            <div className="taskModalHeader">
              <div className="taskBreadcrumb">
                <span
                  className="taskBreadcrumbItem"
                  style={{ color: "#98A3A9" }}
                >
                  Tasks
                </span>
                <AngleRight />
                <span className="taskBreadcrumbItem active">Task details</span>
              </div>

              <div className="activityBtn">
                <Button
                  icon={<ContractsIcon />}
                  className="outlined-btn btn-sm"
                >
                  Activity history
                </Button>
              </div>
            </div>

            <div className="taskModalContent">
              <div className="taskContent">
                <h2>Remove leaves from the front yard</h2>
                <p>
                  Broken sprinkler head near the front walkway
                  <b style={{ fontWeight: "700" }}> needs replacement</b>.
                  Please check the whole zone for other potential issues. and
                  follow these steps:
                </p>
                <ol>
                  <li>
                    Inspect all sprinkler heads in the area for clogs, leaks, or
                    misalignment.
                  </li>
                  <li>
                    Test irrigation coverage to ensure the zone is watering
                    evenly.
                  </li>
                  <li>Remove any debris or mulch blocking sprinkler heads.</li>
                </ol>
              </div>
              <div className="taskAttachments">
                <Row>
                  <div
                    className="attachmentsTitle"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      marginBottom: "12px",
                    }}
                  >
                    <h3>Attachments</h3>
                    <Button icon={<PlusIcon />} className="outlined-btn btn-sm">
                      Add attachments
                    </Button>
                  </div>
                </Row>
                <Row gutter={12}>
                  <Col span={12} className="attachmentCarousel">
                    <div className="attachmentTag">
                      <Tag className="shaded_green_tag">Before</Tag>
                    </div>
                    <Carousel arrows infinite={false}>
                      <div>
                        <img
                          src="/images/work-orders/landscape-demo.jpg"
                          alt="Attachment 1"
                          style={{
                            width: "100%",
                            height: "160px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div>
                        <img
                          src="/images/work-orders/landscape-demo.jpg"
                          alt="Attachment 1"
                          style={{
                            width: "100%",
                            height: "160px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div>
                        <img
                          src="/images/work-orders/landscape-demo.jpg"
                          alt="Attachment 1"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </Carousel>
                  </Col>
                  <Col span={12}>
                    <Card className="requiredProofCard">
                      <div className="attachmentTag">
                        <Tag className="shaded_red_tag">After</Tag>
                      </div>
                      <div className="attachmentImage">
                        <img
                          src="/images/potential-deals/image-icon.svg"
                          style={{ width: "48px", height: "48px" }}
                          alt=""
                        />
                      </div>
                      <div className="switchBox">
                        <Switch
                          onChange={() => setRequiredProof(!requiredProof)}
                          checked={requiredProof}
                        />
                        <div>
                          <div className="requiredHeading">
                            Requires proof of completion
                          </div>
                          <div className="requiredParagraph">
                            The crew leader will be required to take a photo or
                            video upon visit completion.
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
              <div className="taskLocation">
                <h3 style={{ marginBottom: "12px" }}>Location</h3>
                <Image
                  src="/images/work-orders/location.png"
                  preview={false}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </Card>
        </Col>
        <Col flex="360px" className="TaskModalRight">
          <div className="taskSidebarWrapper">
            <div className="taskSidebarHeader">
              <h4>Details</h4>
            </div>

            <div className="sidebarRow">
              <div className="sidebarLabel">Status</div>
              <div className="sidebarValue">
                <Dropdown
                  menu={{
                    items: statusItems,
                    selectable: true,
                  }}
                  trigger={["click"]}
                  overlayClassName="status_dropdown_overlay"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    className={`status_dropdown`}
                  >
                    Scheduled
                    <div className="icon_arrow">
                      <CaretDownOutlined />
                    </div>
                  </Button>
                </Dropdown>
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Occurrences</div>
              <div className="sidebarValue">32</div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Assignee</div>
              <div className="sidebarValue">
                <div className="textWithAvatar">
                  <Avatar src="/images/dummy/user.png" />
                  <div className="avatarText">Jack M.</div>
                </div>
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Source</div>
              <div className="sidebarValue">Client complaint</div>
            </div>
          </div>

          <div className="taskSidebarWrapper">
            <div className="taskSidebarHeader">
              <h4>Property</h4>
            </div>

            <div className="sidebarRow">
              <div className="sidebarLabel">Property</div>
              <div className="sidebarValue">
                <span>Maple office building</span>
                <Button
                  icon={
                    <Image
                      src="/images/work-orders/link-icon.svg"
                      preview={false}
                    />
                  }
                  className="only_icon"
                />
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Contract</div>
              <div className="sidebarValue">
                <span>Warm Season Weekly Maintenance</span>
                <Button
                  icon={
                    <Image
                      src="/images/work-orders/link-icon.svg"
                      preview={false}
                    />
                  }
                  className="only_icon"
                />
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Service</div>
              <div className="sidebarValue">Tree removal</div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Production manager</div>
              <div className="sidebarValue">
                <div className="textWithAvatar">
                  <Avatar src="/images/dummy/user.png" />
                  <div className="avatarText">Jack M.</div>
                </div>
              </div>
            </div>
            <div className="sidebarRow">
              <div className="sidebarLabel">Property address</div>
              <div className="sidebarValue">
                <span>1285 Maplewood Drive Springfield, IL 62706</span>
                <Button
                  icon={
                    <Image
                      src="/images/work-orders/link-icon.svg"
                      preview={false}
                    />
                  }
                  className="only_icon"
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default TaskModal;
